<template>
  <div>
    <layout-content-vertical-nav :nav-menu-items="navMenuItems">
      <slot></slot>

      <template #basket>
        <product-basket v-if="$store.state.app.basketDrawer"></product-basket>
      </template>

      <template #navbar="{ toggleVerticalNavMenuActive }">
        <div
          v-if="$vuetify.breakpoint.mdAndUp"
          class="d-flex align-center flex-grow-1"
        >
          <v-btn
            v-if="$vuetify.breakpoint.mdAndDown"
            rounded
            plain
            class="ml-n4"
            depressed
            style="height: 56px !important"
            @click="toggleVerticalNavMenuActive"
          >
            <v-icon size="32" left style="color: #fff !important">
              {{ icons.mdiMenu }}
            </v-icon>
          </v-btn>
          <CustomerList
            v-if="$ability.can('view', 'asl-customer-select')"
            class="flex-grow-1"
          />
          <EventHeader v-else class="flex-grow-1" />
          <CallCenterCount v-if="$ability.can('view', 'callCenter')" />
          <CustomerLimit v-if="$ability.can('read', 'asl-limit')" />
          <AppBarBasket v-if="$ability.can('view', 'asl-basket')" />
          <!-- <v-card rounded="pill" class="ms-3">
            <CustomerMenu />
            <v-btn
              v-if="$vuetify.breakpoint.mdAndDown"
              color="#f9b000"
              rounded
              depressed
              style="height: 56px !important"
              @click="toggleVerticalNavMenuActive"
            >
              <v-icon size="23" left style="color: #fff !important">
                {{ icons.mdiMenu }}
              </v-icon>
              <span style="color: #fff !important"> Menu </span>
            </v-btn>
          </v-card> -->
        </div>

        <div v-else style="width: 100%">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-btn
                v-if="$vuetify.breakpoint.mdAndDown"
                rounded
                plain
                class="ml-n4"
                depressed
                style="height: 56px !important"
                @click="toggleVerticalNavMenuActive"
              >
                <v-icon size="32" left style="color: #fff !important">
                  {{ icons.mdiMenu }}
                </v-icon>
                <span style="color: #fff !important"> Menu </span>
              </v-btn>
            </div>
            <AppBarBasket v-if="$ability.can('view', 'asl-basket')" />
          </div>
          <div class="logo-center-mobile">
            <router-link
              to="/"
              class="d-flex align-center text-decoration-none"
            >
              <v-img
                :src="newLogo"
                max-height="48px"
                max-width="80px"
                alt="logo"
                contain
                eager
                class="app-logo"
              ></v-img>
            </router-link>
          </div>
        </div>
      </template>
    </layout-content-vertical-nav>
  </div>
</template>

<script>
// Compasition Api
import { computed, onMounted, ref } from "@vue/composition-api";

// Store
import store from "@/store";

// Util
import { getVuetify } from "@core/utils";
import themeConfig from "@themeConfig";
import { postData } from "@utils";

// Components
import LayoutContentVerticalNav from "@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue";
import navMenuItems from "@/navigation/vertical";
import AppBarBasket from "@/components/AppBarBasket.vue";
import ProductBasket from "@/components/basket/BasketList.vue";
import CustomerList from "@/components/CustomerList.vue";
import CustomerLimit from "@/components/TheHeader/CustomerLimit.vue";
import CallCenterCount from "@/components/TheHeader/CallCenterCount.vue";
import CustomerMenu from "@/components/TheHeader/CustomerMenu.vue";

// Icon
import { mdiMenu } from "@mdi/js";
import EventHeader from "@/components/TheHeader/EventHeader.vue";

export default {
  components: {
    CustomerLimit,
    CallCenterCount,
    LayoutContentVerticalNav,
    AppBarBasket,
    ProductBasket,
    CustomerList,
    CustomerMenu,
    EventHeader,
  },
  setup() {
    const $vuetify = getVuetify();
    const userData = JSON.parse(localStorage.getItem("userData"));

    const isLogoShow = computed(() => {
      const result = [];

      // İstenilen şart
      const condition = (item) => item === true;

      // ŞART 1 => Ekran ölçüsüne göre
      $vuetify.breakpoint.mdAndDown ? result.push(true) : result.push(false);

      // ŞART 2 => Kullanıcı tipine göre
      result.push(["CUST", "DEAL", "SUBE", "BAYI"].includes(userData.role));

      return result.every(condition);
    });

    const isLogoTextShow = computed(() => {
      const result = [];

      // İstenilen şart
      const condition = (item) => item === true;

      // ŞART 1 => Ekran ölçüsüne göre
      $vuetify.breakpoint.lgAndUp ? result.push(true) : result.push(false);

      // ŞART 2 => Kullanıcı tipine göre
      result.push(["CUST", "DEAL", "SUBE", "BAYI"].includes(userData.role));

      return result.every(condition);
    });

    const isCustomerLimitShow = computed(() => {
      return ["CUST", "PLSYR", "DEAL", "SUBE", "BAYI", "COMMAN"].includes(
        userData.role
      );
    });

    const isCustomerListShow = computed(() => {
      const result = [];

      // İstenilen şart
      const condition = (item) => item === true;

      // ŞART 1 => Kullanıcı tipine göre
      result.push(
        [
          "COMM",
          "FIN",
          "SUPER",
          "DIST",
          "CASHREPADMIN",
          "MNGR",
          "PLSYR",
          "COMMAN",
        ].includes(userData.role)
      );

      return result.every(condition);
    });

    const isEventShow = computed(() => {
      const result = [];

      // İstenilen şart
      const condition = (item) => item === true;

      // ŞART 1 => Ekran ölçüsüne göre
      $vuetify.breakpoint.smAndDown ? result.push(false) : result.push(true);

      // ŞART 2 => Kullanıcı tipine göre
      result.push(["CUST", "DEAL", "SUBE", "BAYI"].includes(userData.role));

      return result.every(condition);
    });

    const isBasketShow = computed(() => {
      const result = [];

      // İstenilen şart
      const condition = (item) => item === true;

      // ŞART 1 => Kullanıcı tipine göre
      result.push(
        ["CUST", "PLSYR", "DEAL", "SUBE", "BAYI", "COMUSR", "COMMAN"].includes(
          userData.role
        )
      );

      return result.every(condition);
    });

    const isCustomerMenuShow = computed(() => {
      const result = [];

      // İstenilen şart
      const condition = (item) => item === true;

      // ŞART 1 => Ekran ölçüsüne göre
      $vuetify.breakpoint.xs ? result.push(false) : result.push(true);

      return result.every(condition);
    });

    return {
      isLogoShow,
      isLogoTextShow,
      isCustomerLimitShow,
      isCustomerListShow,
      isBasketShow,
      isCustomerMenuShow,
      isEventShow,
      navMenuItems,
      userData,
      appLogoDark: themeConfig.app.logoDark,
      textLogoDark: themeConfig.app.textLogoDark,
      newLogo: themeConfig.app.newLogo,
      icons: {
        mdiMenu,
      },
    };
  },
};
</script>
<style>
.logo-center-mobile {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
